<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{recommendationData.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <v-layout column>
          <v-flex>

            <v-layout row class="elevation-1 white mb-4 pa-3">
              <v-flex xs6>
                <v-avatar
                    :tile="false"
                    :size="72"
                    color="grey lighten-4"
                    class="ma-3 float-left"
                >
                  <img :src="recommendationData.created_user.photo.url_resized" alt="avatar">
                </v-avatar>
                <div>
                  <p class="title mt-4">{{recommendationData.created_user.surname + ' ' + recommendationData.created_user.first_name + ' ' + recommendationData.created_user.patronymic}}</p>
                  <p class="body-2 mt-3">{{recommendationData.created_user.user_group.title}}</p>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row class="elevation-1 white mb-4 pa-3">
              <v-flex xs6>
                <div>
                  <span class="title">Дата создания: </span>
                  <span class="title font-weight-thin">{{ $moment(recommendationData.created_datetime).format('D MMM YYYY, HH:mm') }}</span>
                </div>
                <div class="mt-1">
                  <span class="title">% от продаж: </span>
                  <span class="title font-weight-thin">{{recommendationData.bonus_percent}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Вычет за возврат: </span>
                  <span class="title font-weight-thin">{{recommendationData.refund_percent}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Максимальный бонус: </span>
                  <span class="title font-weight-thin">{{recommendationData.bonus_max_sum}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Минимальная сумма заказа: </span>
                  <span class="title font-weight-thin">{{recommendationData.min_order_sum}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Минимальный вес заказа: </span>
                  <span class="title font-weight-thin">{{recommendationData.min_order_weight}}</span>
                </div>
              </v-flex>
            </v-layout>

            <p class="title">Описание</p>
            <v-layout row class="elevation-1 white mb-4 pa-3">
              <v-flex xs8>
                <div class="text-xs-left subheading">{{recommendationData.description}}</div>
              </v-flex>
            </v-layout>

            <p class="title">Торговые точки</p>
            <v-layout row v-if="pointListTreeData !== null && pointListTreeData.length > 0" class="elevation-1 white mb-4 pa-3">
              <v-flex xs12 lg6 md6>
                <tree
                    :options="{
                        checkbox: true
                      }"
                    :data="pointListTreeData"
                    class="tree--small tree-single-page"
                />
              </v-flex>
            </v-layout>

            <v-layout row v-if="productGroupList !== null && productGroupList.length > 0">
              <v-flex xs12 lg6 md6>
                <p class="title">Группы товаров</p>
                <div
                    class="my-3 pa-2 elevation-1 white"
                    v-for="(productGroup, index) in productGroupList"
                    :key="index"
                >
                  <v-layout>
                    <v-flex xs4 lg4 md4 class="ml-3">
                      <div><span class="subheading font-weight-black">{{productGroup.title}}</span></div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="productGroup.skuList.length > 0">
                    <v-flex xs12 lg12 md12>
                      <div class="text-lg-left subheading font-weight-black pl-3">Список SKU:</div>
                      <div class="text-lg-left subheading pl-3 py-0" v-for="(product, index) in productGroup.skuList" :key="index">{{product}}</div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>

            <p class="text-xs-left title" v-if="recommendationStatistics !== null" id="statistics">Статистика</p>
            <v-layout row class="elevation-1 white mb-4 pa-3" v-if="recommendationStatistics !== null">
              <v-flex xs12>

                <template>
                  <v-card>
                    <v-card-title>
                      <v-layout row>
                        <v-flex xs6 lg6 md6>
                          <v-text-field
                              v-model="statisticsSearch"
                              append-icon="search"
                              label="Поиск"
                              hide-details
                              class="mr-3"
                              @input="onSearch()"
                              outline
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 lg6 md6>
                          <v-select
                              :items="branchTitleList"
                              label="Филиал"
                              v-model="branch"
                              class="mr-3"
                              @input="onBranchSelect()"
                              hide-details
                              outline
                              no-data-text="Нет данных"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                    <v-data-table
                        :headers="statisticsHeaders"
                        :items="statisticsData"
                        class="statistics-table"
                        :rows-per-page-items="[20]"
                        no-data-text="Нет данных"
                        no-results-text="Нет данных"
                        :loading="isStatisticsLoading"
                    >
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th></th>
                          <th v-for="head in props.headers">
                            {{ head.text }}
                          </th>
                          <th>
                            Итого
                          </th>
                        </tr>
                        <tr>
                          <th>Торговая точка</th>
                          <th v-for="head in productGroupList">
                            % Заказов / Бонус
                          </th>
                          <th>% Заказов / Бонус</th>
                        </tr>
                      </template>
                      <tr slot="items" slot-scope="props">
                        <td>{{ props.item.point.title }}</td>
                        <td v-for="productGroup in props.item.productGroups" class="cell-text-center">
                          {{ productGroup.order_percent }} % / {{ productGroup.bonus_sum }} ₽
                        </td>
                        <td class="cell-text-center">{{ props.item.order_percent }} % / {{ props.item.bonus_sum }} ₽</td>
                      </tr>
                    </v-data-table>
                    <div class="text-xs-center pt-2">
                      <v-pagination v-model="statisticsPage" :length="statisticsPages" :total-visible="7" @input="statisticsChangePage()"></v-pagination>
                    </div>
                  </v-card>
                </template>

              </v-flex>
            </v-layout>

            <v-layout row class="pa-0 mt-3 mb-3">
              <v-flex xs12 lg12 md12>
                <div class="float-left inline-block">
                  <p class="title">Дата начала</p>
                  <v-date-picker
                      class="mr-3 ml-0 mt-0 mb-3"
                      locale="ru"
                      readonly
                      :value="$moment(recommendationData.start_date).format('YYYY-MM-DD')"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </div>
                <div class="inline-block">
                  <p class="title">Дата окончания</p>
                  <v-date-picker
                      class="mr-3 ml-0"
                      locale="ru"
                      readonly
                      :value="$moment(recommendationData.end_date).format('YYYY-MM-DD')"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </div>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editRecommendation(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить рекомендацию?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteRecommendationConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Рекомендации', link: '/recommendations/active'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pageDataReady: {
          isReady: false,
          recommendationData: false,
          statistics: false,
          branchList: false
        },
        pointListTreeData: [],
        pointFolderIdList: [],
        pointIdList: [],
        productGroupList: [],
        deleteDialog: false,
        statisticsData: [],
        statisticsSearch: '',
        statisticsHeaders: [],
        statisticsPage: 1,
        statisticsLimit: 20,
        isStatisticsLoading: false,
        branch: null,
        branchId: null
      }
    },
    beforeCreate () {
      this.branch = null
      this.branchId = null

      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getRecommendationSingle', {id: this.$route.params.id})
    },
    computed: {
      recommendationData () {
        return this.$store.getters.recommendationSingle
      },
      recommendationStatistics () {
        return this.$store.getters.recommendationStatistics
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      statisticsPages () {
        return Math.ceil(this.statisticsData.length / this.statisticsLimit)
        // return Math.ceil(this.$store.getters.recommendationStatisticsTotalCount / this.statisticsLimit)
      }
    },
    methods: {
      editRecommendation (id) {
        this.$router.push('/recommendations/edit/' + id)
      },
      deleteRecommendationConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteRecommendation', {id: this.id})
        this.$router.push('/recommendations/active/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.recommendationData) {
          return false
        }
        if (!this.pageDataReady.statistics) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== undefined && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
        } else {
          this.branchId = null
        }
        this.getStatisticsData()
      },
      onSearch () {
        this.statisticsPage = 1
        this.getStatisticsData()
      },
      pointTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeData(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      },
      getStatisticsData () {
        this.isStatisticsLoading = true
        this.$store.dispatch('getRecommendationStatistics', {
          id: this.id,
          q: this.statisticsSearch,
          branchId: this.branchId,
          limit: this.statisticsLimit,
          offset: (this.statisticsPage - 1) * this.statisticsLimit
        })
      },
      statisticsChangePage () {
        document.getElementById('statistics').scrollIntoView()
        scrollBy(0, -80)

        this.getStatisticsData()
      }
    },
    watch: {
      recommendationData (n, o) {
        this.pageDataReady.recommendationData = true
        this.pageDataStatus()

        if (typeof this.recommendationData.point_folder_list !== 'undefined') {
          this.pointFolderIdList = []
          for (let i = 0; i < this.recommendationData.point_folder_list.length; i++) {
            this.pointFolderIdList.push(this.recommendationData.point_folder_list[i].id)
          }
        }

        if (typeof this.recommendationData.point_list !== 'undefined') {
          this.pointIdList = []
          for (let i = 0; i < this.recommendationData.point_list.length; i++) {
            this.pointIdList.push(this.recommendationData.point_list[i].id)
          }
        }

        if (typeof this.recommendationData.recommendation_product_group_list !== 'undefined') {
          this.productGroupList = []
          for (let i = 0; i < this.recommendationData.recommendation_product_group_list.length; i++) {
            this.productGroupList[i] = {
              title: this.recommendationData.recommendation_product_group_list[i].title,
              skuList: [],
              id: this.recommendationData.recommendation_product_group_list[i].id
            }

            for (let k = 0; k < this.recommendationData.recommendation_product_group_list[i].product_sku_list.length; k++) {
              this.productGroupList[i].skuList[k] = this.recommendationData.recommendation_product_group_list[i].product_sku_list[k].title
            }
          }
        }

        for (let i = 0; i < this.productGroupList.length; i++) {
          this.statisticsHeaders.push({ text: this.productGroupList[i].title, sortable: false, value: false })
        }

        if (typeof this.recommendationData.point_folder_tree !== 'undefined') {
          this.pointListTreeData = this.pointTreeData(this.recommendationData.point_folder_tree)
        }

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Рекомендации', link: '/recommendations/active'}
        ]
        this.breadcrumbs.push({name: this.recommendationData.title})

        this.$store.commit('setPageTitle', this.recommendationData.title)

        this.id = this.recommendationData.id
        if (this.recommendationData.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        this.actions.canUpdate = this.recommendationData.can_update
        this.actions.canRemove = this.recommendationData.can_remove

        this.getStatisticsData()
      },
      recommendationStatistics (val) {
        this.pageDataReady.statistics = true
        this.pageDataStatus()

        this.statisticsData = []
        for (let i = 0; i < this.recommendationStatistics.length; i++) {
          this.statisticsData[i] = {}
          this.statisticsData[i].order_percent = this.recommendationStatistics[i].order_percent
          this.statisticsData[i].point = this.recommendationStatistics[i].point
          this.statisticsData[i].bonus_sum = this.recommendationStatistics[i].bonus_sum
          this.statisticsData[i].productGroups = []
          for (let k = 0; k < this.productGroupList.length; k++) {
            for (let j = 0; j < this.recommendationStatistics[i].recommendaion_product_group_statistics_list.length; j++) {
              if (this.productGroupList[k].id === this.recommendationStatistics[i].recommendaion_product_group_statistics_list[j].product_group_id) {
                this.statisticsData[i].productGroups[k] = this.recommendationStatistics[i].recommendaion_product_group_statistics_list[j]
              }
            }
          }
        }

        console.log(this.statisticsData)

        this.isStatisticsLoading = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Recommendations/RecommendationSingle.vue